exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-status-wrapper .status > div {\n  display: inline-block;\n}\n.product-status-wrapper .status > div p {\n  margin: 0;\n}\n", ""]);

// exports
